<template>
	<div class="page">
		<el-menu :default-active="banging" class="el-menu-vertical-demo bian_1"
			background-color="#545c64" text-color="#999999" active-text-color="#FFFFFF" @select="dianjia">
			
			<el-menu-item index="1" >
				<!-- <div class="zuo_3"></div> -->
				<img class="zuo_1" src="../../static/image/9.png" v-if="banging != 1" alt="" srcset="">
				<img class="zuo_1" src="../../static/image/9_1.png" v-if="banging == 1" alt="" srcset="">
				<span slot="title">数据总览</span>
			</el-menu-item>
			<el-menu-item index="2">
				<img class="zuo_1" src="../../static/image/10.png" v-if="banging != 2" alt="" srcset="">
				<img class="zuo_1" src="../../static/image/10_1.png" v-if="banging == 2" alt="" srcset="">
				<span slot="title">学习视频</span>
			</el-menu-item>
			<el-menu-item index="3">
				<img class="zuo_1" src="../../static/image/11.png" v-if="banging != 3" alt="" srcset="">
				<img class="zuo_1" src="../../static/image/11_1.png" v-if="banging == 3" alt="" srcset="">
				<span slot="title">卡号管理</span>
			</el-menu-item>
			<el-submenu index="8">
				<template slot="title">
					<img class="zuo_1" src="../../static/image/12.png" alt="" srcset="">
					<span>系统管理</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="4">关于我们</el-menu-item>
					<el-menu-item index="5">帮助反馈</el-menu-item>
					<el-menu-item index="6">用户协议</el-menu-item>
					<el-menu-item index="7">隐私政策</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
		</el-menu>
	</div>
</template>

<script>
	export default {
		name: 'nav-footer',
		data() {
			return {
				banging: '1',
				tobList: [],
				url_list : [
					{id:1,name:'首页',puth:'index'},
					{id:2,name:'学习视频',puth:'video'},
					{id:3,name:'卡片管理',puth:'card'},
					{id:4,name:'关于我们',puth:'aboutUs'},
					{id:5,name:'帮助反馈',puth:'feedback'},
					{id:6,name:'用户协议',puth:'agreement'},
					{id:7,name:'隐私政策',puth:'privacy'},
				],
				// myInfo:true
			}
		},
		watch: {
			//监听路由地址的改变
			$route: {
				immediate: true,
				handler() {
					if (this.$route.path == '/myInfo') {
						this.banging = ''
					}
				}
			}
		},
		mounted() {},
		created() {
			let index = ''
			if (window.sessionStorage.getItem('statusType')) {
				index = window.sessionStorage.getItem('statusType')
				this.banging = index
			}
		},
		methods: {
			dianjia(item){
				this.banging = item
				this.$emit('custom-event', item); // 触发事件
				this.tobTap(item)
			},
			tobTap(item) {
				let index = ''
				if (window.sessionStorage.getItem('statusType')) {
					index = window.sessionStorage.getItem('statusType')
				}
				if(index == item){
					return
				}
				window.sessionStorage.setItem('statusType', item);
				let url = ''
				
				if(item == 1){
					url = 'index'
				}else if(item == 2){
					url = 'video'
				}else if(item == 3){
					url = 'card'
				}else if(item == 4){
					url = 'aboutUs'
				}else if(item == 5){
					url = 'feedback'
				}else if(item == 6){
					url = 'agreement'
				}else if(item == 7){
					url = 'privacy'
				}
				
				this.$router.push({
					name: url,
				});
				
			}
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep{
		.el-menu-item,
		.el-menu-item-group,
		.el-submenu__title{
			background: #2D3038 !important;
		}
		
	}
	.page {
		width: 220px;
		min-height: 100vh;
		// height: 100%;
		background: #fff;
		text-align: center;
		// padding: 14px 0 0 0;
		border-right: 1px solid #EEEEEE;
	}
	.bian_1{
		height: 100%;
		text-align: left;
		background: #2D3038 !important;
	}
	.zuo_1{
		width: 18px;
		height: 18px;
		margin: 0 10px 0 0;
	}
	.zuo_2{
		// background: #2D3038;
		position: relative;
		
	}
	.zuo_3{
		width: 196px;
		height: 88px;
		background: linear-gradient( 90deg, #44454C 0%, #2D3038 100%) !important;
		border-radius: 8px 8px 8px 8px;
		position: absolute;
		left: 14px;
	}
</style>